import { EmergencyContact } from "@app/project/model/emergency-contact";
import { State } from "@app/root-store/app.state";
import { createSelector } from "@ngrx/store";
import { EmergencyContactState, initialEmergencyContactState } from "../reducers/emergency-contacts.reducers";

const selectFeature = (state: State) => state["emergency-contact"];

const selectActiveEmergencyContacts = (state: EmergencyContactState) =>
    state?.activeProjectEmergencyContacts || initialEmergencyContactState.activeProjectEmergencyContacts;

export const getActiveEmergencyContactsState = createSelector(selectFeature, (state: EmergencyContactState) =>
    selectActiveEmergencyContacts(state)
);

export const getActiveEmergencyContacts = createSelector(selectFeature, (state: EmergencyContactState) => {
    const contactList = selectActiveEmergencyContacts(state).result;
    return (
        Object.values(contactList || {}).sort(
            (contact1: EmergencyContact, contact2: EmergencyContact) => +contact1.order - +contact2.order
        ) || []
    );
});
